import 'picturefill';
import 'lazysizes';
import Rellax from 'rellax';
import { debounce } from 'throttle-debounce';
import AOS from 'aos';
window.addEventListener('DOMContentLoaded', () => {
    const rellax = new Rellax('.js-rellax', {
        vertical: true,
        horizontal: false
    });
    window.addEventListener('resize', debounce(100, () => {
        rellax.refresh();
    }));
});
window.addEventListener('load', () => {
    AOS.init({
        anchorPlacement: 'center-bottom',
        //once: true
    });
});
